import { TypesRoutes } from 'routes/mixedRoutes/types'
import { StateCreator } from 'zustand'

import { NavbarState } from './types'

export const createNavbarSlice: StateCreator<NavbarState, [], [], NavbarState> = (set) => ({
  title: '',
  actionIcons: { leftIcon: '', rightIcon: '' },
  hideNavbar: false,
  firstPage: TypesRoutes.START,
  customBackListener: undefined,

  setNavbarTitle: (title) => set(() => ({ title })),
  setActionIcons: (actionIcons) => set(() => ({ actionIcons })),
  setHideNavbar: (hideNavbar) => set(() => ({ hideNavbar })),
  setFirstPage: (firstPage) => set(() => ({ firstPage })),
  setCustomBackListener: (customBackListener) => set(() => ({ customBackListener })),
  resetNavbar: () =>
    set(() => ({
      title: '',
      actionIcons: { leftIcon: '', rightIcon: '' },
      hideNavbar: false,
    })),
})
